import { React } from 'react';
import { Flex, Icon, Tooltip } from '@chakra-ui/react';
import { CgInfo } from 'react-icons/cg';

function TooltipIcon({ helpText }) {
  return (
    <Tooltip
      fontSize='sm'
      fontWeight='400'
      color='grey.900'
      bg='white'
      border='1px solid #D0D0D0'
      boxShadow='0px 41px 60px 11px rgba(161, 161, 161, 0.160047)'
      borderRadius='16px'
      p='24px'
      maxWidth='600px'
      aria-label='A tooltip'
      placement='bottom-start'
      label={helpText}>
      <Flex alignItems='center'>
        <Icon as={CgInfo} boxSize={5} color='blue.500' ml='8px' />
      </Flex>
    </Tooltip>
  );
}

export default TooltipIcon;
